var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#0F0",
    strokeWidth: 3,
    cx: 20,
    cy: 20,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.707 19.293L19 11.586 17.586 13l6 6H13c-.553 0-.553 2 0 2h10.586l-6 6L19 28.414l7.707-7.707a.999.999 0 000-1.414z",
    fill: "#0F0",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIHN0cm9rZT0iIzBGMCIgc3Ryb2tlLXdpZHRoPSIzIiBjeD0iMjAiIGN5PSIyMCIgcj0iMTguNSIvPjxwYXRoIGQ9Ik0yNi43MDcgMTkuMjkzTDE5IDExLjU4NiAxNy41ODYgMTNsNiA2SDEzYy0uNTUzIDAtLjU1MyAyIDAgMmgxMC41ODZsLTYgNkwxOSAyOC40MTRsNy43MDctNy43MDdhLjk5OS45OTkgMCAwMDAtMS40MTR6IiBmaWxsPSIjMEYwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+";
export { SvgRightArrow as ReactComponent };